"use strict";

var $ = require("jquery");

module.exports = exports.default = function () {

    $(document).ready(function () {
        $("#organization-select").hide();
        $("#customer-select").hide();

        $("#CustomerId").prop('disabled', true);
    });

    $('#RoleId').on('select2:select', function (e) {
        var roleId = $('#RoleId').select2('val');

        if (roleId !== "1") {
            $("#organization-select").show();
            $("#customer-select").show();

            $("#CustomerId").prop('disabled', true);
        } else {
            $("#organization-select").hide();
            $("#customer-select").hide();

            $('#CustomerId').val(null).trigger("change");
            $('#OrganizationId').val(null).trigger("change");
        }
    });

    $('#RoleId').on('select2:unselect', function (e) {
        $("#organization-select").hide();
        $("#customer-select").hide();

        $('#CustomerId').val(null).trigger("change");
        $('#OrganizationId').val(null).trigger("change");
    });

    $('#OrganizationId').on('select2:select', function (e) {
        $("#CustomerId").select2('data', null);
        $("#CustomerId").prop('disabled', true);

        var organizationId = $('#OrganizationId').select2('val');
        $('#CustomerId option').remove();

        $.ajax({
            type: "GET",
            url: "/odata/CustomerByOrganization?id=0" + organizationId,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function success(data) {

                var options = $.map(data.value, function (item) {
                    return { id: item.id, text: item.name + " (" + item.reference + ")" };
                });

                $('#CustomerId').select2({
                    data: options,
                    placeholder: "Select customer"
                }).val(null).trigger('change');
                $("#CustomerId").prop('disabled', false);
            }
        });
    });

    $('#OrganizationId').on('select2:unselect', function (e) {
        $('#CustomerId option').remove();
        $("#CustomerId").select2('destroy').val('').select2();
        $("#CustomerId").prop('disabled', true);
    });

    $('#add-role-submit-button').off('click').on('click', function () {
        $("#CustomerId").prop('disabled', false);
        var form = $(this).closest("form");
        var url = form.attr('action');

        $.validator.unobtrusive.parse(form);

        if ($(form).valid()) {
            $.ajax({
                type: "POST",
                url: url,
                data: form.serialize(),
                success: function success(data, textStatus, xhr) {
                    if (xhr.status === 200 && data === "") {
                        window.location.reload();
                    } else {
                        $('#role-modal.modal-content').html(data);
                    }
                }
            });
        }
    });
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/addRole.js
// module id = 409
// module chunks = 0